import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { handleResponse } from 'APIPackage/MainModule/common/handleResponse';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { apiMockSwitcher } from 'APIPackage/MainModule/mock/apiMockSwitcher';

import { ICountry } from '../interfaces/ICountry';

export async function fetchCountries(): Promise<ICountry[]> {
  const url = `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE, false)}/catalogs/erknm/countries`;
  const mockData = apiMockSwitcher<ICountry[]>(url, 'GET');

  if (mockData) return mockData;

  return fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(handleResponse);
}
